export const appImages = {
  registartionPic: require("./images/registration-form-pic.jpg"),
};
